import { createApi } from '../client'

const api = createApi('/lop')

export default api
